import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getCurrentIssue = createAsyncThunk('get currentIssue data', async () => {
  try {
    const result = await $api.get(`/current-issue`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateCurrentIssue = createAsyncThunk('update currentIssue data', async data => {
  try {
    const result = await $api.put(`/current-issue`, data)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
}

export const currentIssueSlice = createSlice({
  name: 'currentIssue',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCurrentIssue.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getCurrentIssue.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getCurrentIssue.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })
  },
})

export const { actions: currentIssueActions } = currentIssueSlice
export const { reducer: currentIssueReducer } = currentIssueSlice
